import { parseInboundPayload } from '../../inbound';
import { createArrayWithBracesParser, numberParser, stringParser } from '../../inboundParsers';
import { splitWithBraces, trimBraces } from '../../inboundUtils';
export const inboundPlayerServerSettingsParser = createArrayWithBracesParser(inboundPlayerServerSettingParser);
export function inboundPlayerServerSettingParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, inboundPlayerServerSettingPartDefinitions);
}
const inboundPlayerServerSettingPartDefinitions = [
    { name: 'type', parser: stringParser },
    { name: 'currentValueIndex', parser: numberParser },
    { name: 'values', parser: createArrayWithBracesParser(stringParser) }
];
